module.exports = __webpack_public_path__ + "c031b08a538bc4163a4ab76e8dbcd7c0.MP3";